import React, { Component, Fragment } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, Table, TableHead, TableRow, TableCell, TableBody, Collapse } from '@material-ui/core';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { roleName } from '../../common/common';
import { timeFormat } from '../../common/utils';

const Root = styled(Box)({
    width: '100%',
    overflowX: 'auto',
    '& .tableHead': {
        paddingLeft: '40px',
        height: '60px',
        color: '#9B9B9B',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
    },
    '& .iconExpand': {
        margin: '0 10px',
        transform: "rotate(0deg)",
        color: '#9B9B9B',
    },
    '& .iconClose': {
        margin: '0 10px',
        transform: "rotate(-90deg)",
        color: '#9B9B9B',
    },
    '& .extend': {
        backgroundColor: '#fff',
    },
    '& .expandBtn': {
        cursor: 'pointer',
        height: '60px',
        color: '#005F9B',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        borderBottom: '1px solid #D8D8D8',
    },
    '& .closeBtn': {
        cursor: 'pointer',
        height: '60px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #D8D8D8',
    },
    '& .table': {
        minWidth: '650px',
    },
    '& .w290': {
        width: '290px',
    },
    '& .noTeams': {
        height: '60px',
        color: '#9B9B9B',
        borderBottom: '1px solid #D8D8D8',
    },
    '& .hCell': {
        padding: '0 16px',
        color: '#FEFCFF',
        backgroundColor: '#CDCBD0',
    },
    '& .bCell': {
        backgroundColor: '#F5FBFF',
    },
})

const DEPT = "dept_manager";
const TEAM = "team_leader";
const STAFF = "staff";
class FoldTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deptsData: [],
        }
        this.handleClickItem = this.handleClickItem.bind(this);
        this.handleAddTeam = this.handleAddTeam.bind(this);
        this.handleDeptView = this.handleDeptView.bind(this);
        this.handleDeptEdit = this.handleDeptEdit.bind(this);
        this.handleDeptDel = this.handleDeptDel.bind(this);
        this.handleTeamView = this.handleTeamView.bind(this);
        this.handleTeamEdit = this.handleTeamEdit.bind(this);
        this.handleTeamDel = this.handleTeamDel.bind(this);
    }
    render() {
        const {
            deptsData,
        } = this.state;
        const tableView = (row) => {
            if (row.teams.length > 0) {
                return <Table stickyHeader className="table">
                    <TableHead>
                        <TableRow role="checkbox">
                            <TableCell className="hCell"></TableCell>
                            <TableCell className="hCell">Team Name</TableCell>
                            <TableCell className="hCell">Team Member</TableCell>
                            <TableCell className="hCell">Update Time</TableCell>
                            <TableCell className="hCell">Create Time</TableCell>
                            <TableCell className="hCell">Others</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {row.teams.map(obj => (
                            <TableRow key={obj.id} role="checkbox">
                                <TableCell className="bCell" component="th" scope="obj"></TableCell>
                                <TableCell className="bCell">{obj.name}</TableCell>
                                <TableCell className="bCell">{this.membersNum(obj.members)}</TableCell>
                                <TableCell className="bCell">{timeFormat(obj.update_time)}</TableCell>
                                <TableCell className="bCell">{timeFormat(obj.create_time)}</TableCell>
                                <TableCell className="bCell">
                                    <div className="h h-l">
                                        <Button variant="outlined" size="small" color="primary" onClick={e => this.handleTeamView(e, obj)}>View</Button>
                                        {teamEditView(obj)}
                                        {/* <DeleteForeverIcon className="del" onClick={e => this.handleTeamDel(e, obj)}></DeleteForeverIcon> */}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            } else {
                return <div className="noTeams c">No Teams</div>
            }
        }
        const teamEditView = (obj) => {
            if (this.isLeader(obj.role)) {
                return <Button variant="outlined" size="small" color="primary" onClick={e => this.handleTeamEdit(e, obj)}>Edit</Button>
            }
        }
        const deptBtnView = (row) => {
            if (roleName === DEPT && row.role.name === DEPT) {
                return <Fragment>
                    <Button variant="outlined" size="small" color="primary" onClick={e => this.handleDeptEdit(e, row)}>Edit</Button>
                    <Button variant="outlined" size="small" color="primary" onClick={e => this.handleAddTeam(e, row)}>Add Team</Button>
                </Fragment>
            }
        }
        return (
            <Root>
                <div className="tableHead h">
                    <div className="f">Office</div>
                    <div className="f">Department. Name</div>
                    <div className="f">Team Amount</div>
                    <div className="f">Update Time</div>
                    <div className="f">Create Time</div>
                    <div className="w290">Operations</div>
                </div>
                {deptsData.map((row, index) => (
                    <div key={index}>
                        <div className={row.expanded ? "expandBtn h" : "closeBtn h"} onClick={e => this.handleClickItem(e, index)}>
                            <ExpandMore className={row.expanded ? "iconExpand" : "iconClose"} />
                            <div className="f h">
                                <div className="f">{row.office}</div>
                                <div className="f">{row.name}</div>
                                <div className="f">{row.teams.length}</div>
                                <div className="f">{timeFormat(row.update_time)}</div>
                                <div className="f">{timeFormat(row.create_time)}</div>
                                <div className="w290 h h-l">
                                    <Button variant="outlined" size="small" color="primary" onClick={e => this.handleDeptView(e, row)}>View</Button>
                                    {deptBtnView(row)}
                                    {/* <DeleteForeverIcon className="del" onClick={e => this.handleDeptDel(e, row)}></DeleteForeverIcon> */}
                                </div>
                            </div>
                        </div>
                        <Collapse className="extend" in={row.expanded} timeout="auto" unmountOnExit>
                            {tableView(row)}
                        </Collapse>
                    </div>
                ))}
            </Root>
        )
    }
    componentDidUpdate(prevProps) {
        if (this.props.deptsData !== prevProps.deptsData) {
            const deptsData = this.props.deptsData;
            if (deptsData) {
                console.log("deptsData", deptsData);
                this.setState(() => ({
                    deptsData
                }));
            }
        }
    }
    handleClickItem(e, index) {
        const [...deptsData] = this.state.deptsData;
        const expanded = deptsData[index].expanded
        deptsData[index].expanded = !expanded;
        this.setState(() => ({
            deptsData
        }));
    }
    handleDeptView(e, obj) {
        e.stopPropagation();
        this.props.handleDeptView(obj);
    }
    handleDeptEdit(e, obj) {
        e.stopPropagation();
        this.props.handleDeptEdit(obj);
    }
    handleDeptDel(e, obj) {
        e.stopPropagation();
        this.props.handleDeptDel(obj);
    }
    handleAddTeam(e, obj) {
        e.stopPropagation();
        this.props.handleAddTeam(obj);
    }
    handleTeamView(e, obj) {
        this.props.handleTeamView(obj);
    }
    handleTeamEdit(e, obj) {
        if (this.props.handleTeamEdit) this.props.handleTeamEdit(obj);
    }
    handleTeamDel(e, obj) {
        this.props.handleTeamDel(obj);
    }
    isLeader(role) {
        if (role.name === TEAM) {
            return true;
        } else if (role.name === DEPT) {
            return true;
        }
        return false;
    }
    membersNum(arr) {
        if (arr) {
            let members = 0;
            for (const obj of arr) {
                if (obj.role.name === STAFF || obj.role.name === TEAM) {
                    members++;
                }
            }
            return members;
        } else {
            return 0;
        }
    }
}

export default FoldTable;